import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { Modal, ModalTitle, ModalFooter } from "@vds/modals";
import { Text } from '@vds/core';
import { MarginSpacerL, MarginSpacerXL } from "common/components/styleTag";
import styled from 'styled-components';
import { useMediaQuery } from "react-responsive";
import { Button } from "@vds/buttons";
import { Tab, Tabs } from '@vds/tabs';
import ImageTile from './ImageTile';
import { TitleLockup } from '@vds3/type-lockups';
import { Icon } from "@vds/icons";
import { Carousel } from "@vds/carousels";
import { DropdownSelect } from '@vds/selects';
import OtherDeviceDetails from './OtherDeviceDetails';

function GetDeviceDetailsModal({ pathUrl,...props }) {
  const { t } = useTranslation(["byod"]);
  const [iOSData, setIOSData] = useState([]);
  const [androidData, setAndroidData] = useState([]);
  const aemData = t("byod", { ns: "byod", returnObjects: true });
   const [deviceType, setDeviceType] = useState("smartphones");

  const [oSData, setOSData] = useState("ios");
  
const windowsDetails = t("byod.get-windows-details-modal.details", {
    ns: "byod",
    returnObjects: true,
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 545px)",
  });

  useEffect(() => {
    const iOSDat = aemData?.iOSData;
    setIOSData(iOSDat);
    const androidDat = aemData?.androidData;
    setAndroidData(androidDat);
  }, [])

  const showIMEIImageModal = t("byod.showIMEIImageModal", { ns: "byod" });

  const onTabChangeFunc = (event) => {
  };
  let getIosList = (item) => <ImageTile data={item}></ImageTile>
  
  let getAndroidList = (item) => <ImageTile data={item}></ImageTile>

   const deviceOptionsList =
    t("byod.deviceListOptions", { ns: "byod", returnObjects: true }) ?? [];
  const operatingSystemOptions = t("byod.operatingSystemOptions.list", { ns: "byod",returnObjects: true }) ?? [];
 

  useEffect(() => {
       deviceOptionsList && deviceOptionsList.forEach((item) => {
      if (pathUrl?.includes(item?.value.toLowerCase())) {
        onDeviceTypeChange(item?.value.toLowerCase());
      }
      else if (pathUrl?.includes('basic-phones') || pathUrl?.includes('mobile-hotspots')) {
        onDeviceTypeChange("other")
    }
    })
  }, [pathUrl]);

  const onDeviceTypeChange = (val) => {
    if (
      val === "smartphones" ||
      val === "tablets" ||
      val === "laptops" || val === "smart-watches" || val === "other"

    ) {
      setDeviceType(val);
    }
    
  }

  const onOSDataChange = (val) => {
    if (
      val === "ios" ||
      val === "android") {      
      setOSData(val)       
        
    }   
  }
  
  const imageDataRender = () => {
    if (deviceType === "smartphones" && oSData === "ios") {
      return aemData?.smartphonesIOSData;
    }
    else if (deviceType === "smartphones" && oSData === "android") {
      return aemData?.smartphonesAndroidData;
    }
    else if (deviceType === "tablets" && oSData === "ios") {
      return aemData?.tabletsIOSData;
    }
    else if (deviceType === "tablets" && oSData === "android") {
      return aemData?.tabletsAndroidData;
    
    }
      else if (deviceType === "laptops") {
      return aemData?.laptopsData
    }
    else if (deviceType === "smart-watches" && oSData === "ios") {
      return aemData?.smartwatchesIOSData;   
    }
     else if (deviceType === "smart-watches" && oSData === "android") {
      return aemData?.smartwatchesAndroidData;   
    }
  
  }
  
  return (
    <>
      <Modal
        hideCloseButton={true}
        disableOutsideClick={true}
        onOpenedChange={(e) => {
          if (!e) {
            props.close(null)
          }
        }
        }
        width={isMobile ? "100%" : "787px"}
        height={isMobile ? "100%" : "674px"}
        fullScreenDialog={isMobile ? true : false}
        opened={!!props.showModal}
        disableFocusLock= {true}
      >
        {showIMEIImageModal === "Y" ?
          <ModalDeviceContainer>
            <ModalTitle>
              <TitleLockup
                data={{
                  title: {
                    size: 'titleMedium',
                    bold:true,
                    children:t("byod.get-device-detail-image-modal.header-text", { ns: "byod" }),
                  },
                  subtitle: {
                    size: 'bodyLarge',
                    children: 
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("byod.get-device-detail-image-modal.subheading-desktop", {
                            ns: "byod",
                          }),
                        }}
                      />,
                    
                  },
                }}
              />
            </ModalTitle>
            <MarginSpacerXL />
            <StyledDropDownDiv>
            <DropdownSelectDiv
              label={t("byod.deviceOptions.label", { ns: "byod" })}
              width={"158px"}
              error={false}
              disabled={false}
              readOnly={false}
              inlineLabel={false}
              value={deviceType}
              onChange={(e) => onDeviceTypeChange(e.target.value)}
            >
             {deviceOptionsList?.map((option) => {
                    return (
                      <option key={option?.value} value={option?.value}>
                        {option?.label}
                      </option>
                    );
                  })}
            </DropdownSelectDiv>                                       
                <DropdownSelectDiv
                label={t("byod.operatingSystemOptions.label", { ns: "byod" })}
                width={"158px"}
                error={false}
                disabled={(deviceType === "other" || deviceType === "laptops") ? true : false}
                readOnly={false}
                inlineLabel={false}
                  value={oSData}
                onChange={(e) => onOSDataChange(e.target.value)}
              >{(deviceType === "other" || deviceType ==="laptops") ?
                  <></>
                  :
                <>
                  {operatingSystemOptions?.map((option) => {
                    return (
                      <option key={option?.value} value={option?.value}>
                        {option?.label}
                      </option>
                    );
                  })}
                  </>
                }
                </DropdownSelectDiv>
              
              
            </StyledDropDownDiv>
            <Text kind="body" size="medium">
                  <div>
                    <MarginSpacerL/>
                {!(deviceType === "other") &&
                  <Carousel
                   layout={isMobile? "1UP":"2UP"}
                    gutter="24px"
                    padding="10px"
                    peek="standard"
                    width='100%'
                    height='450px'
                    surface="light"
                    paginationInset="12px"
                    pagination={{
                      kind: 'lowContrast',
                      hideBorder: true,
                      floating: true,
                    }}
                    paginationDisplay={isMobile ? "persistent" : "onHover"}
                    aspectRatio="1:1"
                    data={imageDataRender() || []}
                    renderItem={(props) => getIosList(props)}
                  />
                }
               
                {deviceType === "other" && (
                  <><OtherDeviceDetails/></>
                )}
               
              </div>
              
            </Text>
          </ModalDeviceContainer>
          :
          <ModalDeviceContainer>
            <ModalTitle>
              <Text kind="title" size="large" bold>
                {t("byod.get-device-detail-modal.header-text", { ns: "byod" })}
              </Text>
            </ModalTitle>
            <MarginSpacerL />

            <Text kind="body" className="helper-text" size="medium">
              {isMobile ?
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("byod.get-device-detail-modal.subheading-mobile", {
                      ns: "byod",
                    }),
                  }}
                />
                :
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("byod.get-device-detail-modal.subheading-desktop", {
                      ns: "byod",
                    }),
                  }}
                />
              }
            </Text>
            <MarginSpacerL />
            <Text kind="body" size="medium">
              <span
                dangerouslySetInnerHTML={{
                  __html: t("byod.get-device-detail-modal.setting", {
                    ns: "byod",
                  }),
                }}
              />
            </Text>
            <ModalFooter
              children={
                <ButtonWrapper
                  width={isMobile ? "100%" : "auto"}
                  onClick={() => props.close(null)}
                >
                  {t("byod.closeBtn", { ns: "byod" })}
                </ButtonWrapper>
              }
            />
          </ModalDeviceContainer>}
      </Modal>
    </>
  );
}
const DropdownSelectDiv = styled(DropdownSelect)`
> div > label > p {
font-size:14px;
}
`
const StyledDropDownDiv = styled.div`
width:328px;
display:flex;
gap:12px;
&& {margin-bottom:16px !important}
@media (max-width:767px){
 && {
  margin-bottom:12px !important;
 }
}
`
const ModalDeviceContainer = styled.div`
 height:70vh;
 p{
    width: 98%;
    >span >p >a {
      color : inherit
    }
 }
 [class^=OuterTileContainer-VDS]{
  padding:10px !important;
  width:249px !important;
  height:300px !important;
  background-color:transparent;
}
[class^=OuteCarouselContainer-VDS]{
  padding-left:0px;
}
[class^=SlotContainer-VDS]{
  flex: 0 0 274px;
}
[class^=StyledTabList-VDS]{
    gap: 10px;
    width: max-content;
}
[class^=CarouselContainer-VDS]{
  padding-left:0px;
  margin-bottom:16px;
  @media only screen and (max-width:767px){
  margin-bottom:12px !important;
  }

}

[class^=StyledGridContainer-VDS]{
  width: 101% !important;
}

[class^="TitleWrapper-VDS"]{
margin-bottom:24px !important;
@media only screen and (max-width:767px){
margin-bottom:24px !important;
}
}

.gFslny{
  border-bottom:4px rgb(238, 0, 0) solid;
}
.loVphc{
  border-bottom:4px rgb(238, 0, 0) solid;
}
[class^="SubtitleWrapper-VDS"] {
  margin-bottom:8px !important;
  @media only screen and (max-width:767px){
  margin-bottom:8px !important;
  }
}
[class^="ScrollbarWrapper-VDS"] {
  margin-bottom:48px !important;
  @media only screen and (max-width:767px){
  margin-bottom:40px !important;
  }
}

 @media only screen and (min-width: 320px) and (max-width: 545px) {
  p{
    width: 95%;
    a{
      color: #000000;
    }
 }
 
}
`;

const StyledTabs = styled(Tabs)`
width: 100%;
`;
const StyledTab = styled(Tab)`
  margin-left: 10px;
`;
const ButtonWrapper = styled(Button)`
@media screen and (max-width:767px){
  position:absolute;
  bottom:16px;
  width:97%;
  right:3%;
}
`;

const ImageSpanStyled = styled.span`
  position: relative;
  top: 2px;
  padding: 0px 3px;
`;


export default GetDeviceDetailsModal